// @flow

import { WayfindingActions, SelectionActions } from "@adactive/arc-map";
import { DefaultSchemaHelper, Tracker } from "@adactive/adsum-client-analytics";
import { ClientAPI as ACA } from "@adactive/adsum-utils";

const trackMapActions = (tracker: Tracker, store: *, action: *) => {
  switch (action.type) {
    case WayfindingActions.types.WILL_DRAW_TO_POI: {
      const poi = ACA.getPoi(action.poiId);
      if (poi !== null) {
        tracker.add(
          DefaultSchemaHelper.getPoiType(),
          DefaultSchemaHelper.getPoiEvent("goTo", poi)
        );
      }
      break;
    }
    case WayfindingActions.types.WILL_DRAW_TO_PLACE: {
      const place = ACA.getPlace(action.placeId);
      if (place !== null) {
        tracker.add(
          DefaultSchemaHelper.getPlaceType(),
          DefaultSchemaHelper.getPlaceEvent("goTo", place)
        );
      }
      const pois = ACA.getPoisFromPlace(place.id);
      if (pois && pois.length > 0) {
        const poi = pois[0];
        console.log("POI GO TO ANALYTICS", poi);
        tracker.add(
          DefaultSchemaHelper.getPoiType(),
          DefaultSchemaHelper.getPoiEvent("goTo", poi)
        );
        if (
          poi &&
          poi.categories &&
          Array.from(poi.categories.values).length > 0 &&
          Array.from(poi.categories.values)[0].value
        ) {
          const id = [Array.from(poi.categories.values)[0].value];
          const categories = ACA.getCategories(id);
          if (categories && categories.length > 0) {
            categories.map((category) => {
              console.log("CATEGORY GO TO ANALYTICS", category);
              tracker.add(
                DefaultSchemaHelper.getCategoryType(),
                DefaultSchemaHelper.getCategoryEvent("goTo", category)
              );
              return category;
            });
          }
          if (
            poi &&
            poi.tags &&
            Array.from(poi.tags.values).length > 0 &&
            Array.from(poi.tags.values)[0].value
          ) {
            const id = Array.from(poi.tags.values)[0].value;
            const tags = ACA.getTagBy({ id });
            if (tags && tags.length > 0) {
              tags.map((tag) => {
                console.log("TAG GO TO ANALYTICS", tag);
                tracker.add(
                  DefaultSchemaHelper.getTagType(),
                  DefaultSchemaHelper.getTagEvent("goTo", tag)
                );
                return tag;
              });
            }
          }
        }
      }
      break;
    }
    case SelectionActions.types.WILL_SELECT: {
      const { adsumObject } = action;
      if (adsumObject && adsumObject.placeId) {
        const place = ACA.getPlace(adsumObject.placeId);
        if (place !== null) {
          tracker.add(
            DefaultSchemaHelper.getPlaceType(),
            DefaultSchemaHelper.getPlaceEvent("select", place)
          );
        }
        const pois = ACA.getPoisFromPlace(place.id);
        if (pois && pois.length > 0) {
          const poi = pois[0];
          console.log("POI GO TO ANALYTICS", poi);
          tracker.add(
            DefaultSchemaHelper.getPoiType(),
            DefaultSchemaHelper.getPoiEvent("goTo", poi)
          );
          if (
            poi &&
            poi.categories &&
            Array.from(poi.categories.values).length > 0 &&
            Array.from(poi.categories.values)[0].value
          ) {
            const id = [Array.from(poi.categories.values)[0].value];
            const categories = ACA.getCategories(id);
            if (categories && categories.length > 0) {
              categories.map((category) => {
                console.log("CATEGORY GO TO ANALYTICS", category);
                tracker.add(
                  DefaultSchemaHelper.getCategoryType(),
                  DefaultSchemaHelper.getCategoryEvent("goTo", category)
                );
                return category;
              });
            }
            if (
              poi &&
              poi.tags &&
              Array.from(poi.tags.values).length > 0 &&
              Array.from(poi.tags.values)[0].value
            ) {
              const id = Array.from(poi.tags.values)[0].value;
              const tags = ACA.getTagBy({ id });
              if (tags && tags.length > 0) {
                tags.map((tag) => {
                  console.log("TAG GO TO ANALYTICS", tag);
                  tracker.add(
                    DefaultSchemaHelper.getTagType(),
                    DefaultSchemaHelper.getTagEvent("goTo", tag)
                  );
                  return tag;
                });
              }
            }
          }
        }
      }
      break;
    }
    default:
  }
};

export default trackMapActions;
